import React from 'react';

import {
  maxDetails,
  infinityDetails,
  coreDetails
} from '../ChecklistsAndContent/content';
import css from '../SetPlan.module.scss';

interface Props {
  plan: string;
}

const detailsMapper = {
  infinity: infinityDetails,
  max: maxDetails,
  standard: coreDetails
};

const PlanTools = ({ plan }: Props) => {
  const details = detailsMapper[plan];
  return (
    <>
      <div className={css.investInfoContainer}>
        {details.map((item, index) => {
          return (
            <div className={css.investInfo} key={index}>
              <img src={`../../../static/${item.image}`} />
              <div>
                <h2>{item.heading}</h2>
                <p>{item.details}</p>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default PlanTools;
